import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { Text } from '@acast-tech/decibel';

export type Column = {
  key: string;
  header: string;
  align?: 'left' | 'right';
  className?: string;
};

type TableProps = {
  columns: Column[];
  header?: boolean;
  className?: string;
  children: React.ReactNode;
};

const Table = ({ columns, header = true, className, children }: TableProps) => {
  return (
    <table className={twMerge('table-auto border-separate border-spacing-y-2', className)}>
      {header && (
        <thead>
          <tr>
            {columns.map((column) => (
              <th
                key={column.key}
                className={twMerge(
                  column.align === 'right' ? 'text-right' : 'text-left',
                  column.className
                )}
              >
                {column.header && (
                  <Text variant="caption" textColor={'#646464'}>
                    {column.header}
                  </Text>
                )}
              </th>
            ))}
          </tr>
        </thead>
      )}

      <tbody>{children}</tbody>
    </table>
  );
};

interface TableRowProps {
  children: ReactNode;
  className?: string;
  selected?: boolean;
  isOtherRowSelected?: boolean;
}

export const TableRow = ({ children, className, isOtherRowSelected }: TableRowProps) => {
  return (
    <tr
      className={twMerge(
        'h-10 transition duration-300',
        isOtherRowSelected && 'opacity-25',
        className
      )}
    >
      {children}
    </tr>
  );
};

interface TableCellProps {
  children: ReactNode;
  className?: string;
  align?: 'left' | 'right';
}

export const TableCell = ({ children, className, align = 'left' }: TableCellProps) => {
  return (
    <td
      className={twMerge(
        'text-sm text-textDarkGrey',
        align === 'right' ? 'text-right' : 'text-left',
        className
      )}
    >
      {children}
    </td>
  );
};
export default Table;
